import FileMixin from '~/mixins/FileMixin'
import PageProductDetail from '~/themes/base/components/product/PageProductDetail'

export default {
  mixins: [PageProductDetail, FileMixin],
  computed: {
    productManuals() {
      return this.product.content.product_manual
    },
  },
  methods: {
    $super: false,
    getEnabledTabsAccordingToProjectSettings() {
      const tabs = PageProductDetail.methods.getEnabledTabsAccordingToProjectSettings.call(this) || []

      if (this.$themeSettings.components.PageProductDetail.files.enable && this.productManuals?.length > 0) {
        tabs.push('files')
      }

      return tabs
    },
  },
}
